/**
 * MediKaLLink patient last messages API (GET ?fb_uid=…).
 */

import { getPatientLastMessagesUrl } from './apiConfig'

export type GetPatientLastMessagesCredentials = {
  bearerToken: string
  csrfToken?: string
}

export { getPatientLastMessagesUrl }

export async function getPatientLastMessages(
  creds: GetPatientLastMessagesCredentials,
  fbUid: string,
): Promise<unknown> {
  const token = (creds.bearerToken || '').trim()
  const uid = (fbUid || '').trim()
  if (!token) {
    throw new Error('Missing MediKaLLink bearer token for patient last messages.')
  }
  if (!uid) {
    throw new Error('Missing patient fb_uid for last messages.')
  }
  const url = getPatientLastMessagesUrl(uid)
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      accept: '*/*',
      Authorization: `Bearer ${token}`,
      'X-CSRF-TOKEN': (creds.csrfToken ?? '').trim(),
    },
  })
  const raw = await res.text().catch(() => '')
  if (!res.ok) {
    throw new Error(
      `Patient last messages HTTP ${res.status}${raw ? `: ${raw.slice(0, 200)}` : ''}`,
    )
  }
  try {
    return raw ? JSON.parse(raw) : {}
  } catch {
    throw new Error(
      `Patient last messages returned invalid JSON${raw ? `: ${raw.slice(0, 200)}` : ''}`,
    )
  }
}
